import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import IString from '~components/general/i-string';

export default function IdentityProviderDetailsAccountList({ linkedAccounts }) {
  return <>
    <div className="sectionTitle flex">
      <IString stringKey={'identityProvider.details.sectionTitles.accounts'} />
    </div>
    <div className="section">
      <div className="tableContainer">
        {linkedAccounts.length === 0
          ? (
            <div className="emptyListMessage">
              <IString stringKey={'identityProvider.details.noAccounts'} />
            </div>
          ) : (
            <table className="contentListing">
              <thead>
                <tr>
                  <th><IString stringKey="general.account" /></th>
                  <th><IString stringKey="general.name" /></th>
                  <th><IString stringKey="account.details.sso_hint" /></th>
                </tr>
              </thead>
              <tbody>
                {linkedAccounts.map(account => (
                  <tr key={account.id}>
                    <td className="value">{account.id}</td>
                    <td className="value"><Link to={`/accounts/${account.id}`}>{account.display_name || account.name}</Link></td>
                    <td className="value">{account.sso_hint}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        }
      </div>
    </div>
  </>;
}

IdentityProviderDetailsAccountList.propTypes = {
  dispatch: PropTypes.func,
  linkedAccounts: PropTypes.arrayOf(
    PropTypes.shape({
      display_name: PropTypes.string,
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      sso_hint: PropTypes.string
    })
  ).isRequired
};
